import { render, staticRenderFns } from "./sales-order.vue?vue&type=template&id=4dbb14d7&"
import script from "./sales-order.vue?vue&type=script&lang=js&"
export * from "./sales-order.vue?vue&type=script&lang=js&"
import style0 from "./sales-order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports